export default __webpack_public_path__ + "static/devesecops-support-mobile2-739032383db8afe42eb96cdeafb71b56.jpg";